module.exports = __webpack_public_path__ + "static/media/P41.368a55b4.jpg";